import { createEventBus } from "@silo/utils";

export const ConnectWalletBus = createEventBus("connect-wallet");
